@switch (touchpointType()) {

<!-- WS4 inc 6 grind: FRIEND LANDING integration (edit-landing-integration.html). A 3-screen
     ft-nav-pane (integrated / custom / hosted) whose active screen + status dot are driven by
     model.integration.landingPageType. On quebec landingPageType==3 → only the hosted screen
     summary + nav render (the url/custom screens, Advanced section, and 3 switch-to-X modals are
     landingPageType-gated → hidden/pixel-inert, but reproduced for fidelity on other properties). -->
@case ('landing') {
<section class="ft-section ft-config-section has-sidenav">
  <div class="ft-container">
    <div class="ft-section-header">
      <div class="ft-label">{{ 'flipto.account.Configuration' | translate }}</div>
      <p class="ft-summary" [innerHTML]="'flipto.account.LandingPageConfigurationSubHeading' | translate"></p>
    </div>
    <div class="ft-row">
      <div class="ft-col-33">
        <ul class="nav editor-nav">
          <li>
            <a class="landing-url" style="display: inline-block;" (click)="screenName.set('landing-url')"
               [class.active]="screenName() === 'landing-url'"
               [innerHTML]="('flipto.account.IntegratedExperience' | translate | uppercase)"></a>
            @if (model().integration?.landingPageType == 1) {
              <span class="panel-status on"
                    style="display: inline-block; position: relative; top: 0px; right: 0px; margin-left: 10px;">On</span>
            }
          </li>
          <li>
            <a class="landing-custom" style="display: inline-block;" (click)="screenName.set('landing-custom')"
               [class.active]="screenName() === 'landing-custom'"
               [innerHTML]="('flipto.account.CustomExperience' | translate | uppercase)"></a>
            @if (model().integration?.landingPageType == 2) {
              <span class="panel-status on"
                    style="display: inline-block; position: relative; top: 0px; right: 0px; margin-left: 10px;">On</span>
            }
          </li>
          <li>
            <a class="landing-hosted" style="display: inline-block;" (click)="screenName.set('landing-hosted')"
               [class.active]="screenName() === 'landing-hosted'"
               [innerHTML]="('flipto.account.HostedExperience' | translate | uppercase)"></a>
            @if (model().integration?.landingPageType == 3) {
              <span class="panel-status on"
                    style="display: inline-block; position: relative; top: 0px; right: 0px; margin-left: 10px;">On</span>
            }
          </li>
        </ul>
      </div>
      <div class="ft-col-66">
        <ft-screen name="landing-url">
          <div [hidden]="screenName() !== 'landing-url'">
            <p class="ft-summary" [innerHTML]="'flipto.account.LandingPageIntegratedDescription' | translate"></p>
            <div class="ft-panel" ft-modal-fields-editor (click)="editLandingPageUrl()">
              <div class="ft-row">
                <div class="ft-col-33">
                  <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.landingPageUrl' | translate }}:</div>
                  <div class="ft-summary">{{ 'flipto.account.platform.preStay.touchpoints.landingPageUrlSummary' | translate }}</div>
                </div>
                <div class="ft-col-66"><div [innerHTML]="placeholderHtml(langData('en')['landingPageUrl'])"></div></div>
              </div>
            </div>
            <div class="ft-panel" ft-modal-fields-editor (click)="editLandingJsonSettings()">
              <div class="ft-row">
                <div class="ft-col-33">
                  <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.JsonSettings' | translate }}:</div>
                </div>
                <div class="ft-col-66"><div [innerHTML]="placeholderHtml(model().integration?.jsonSettings)"></div></div>
              </div>
            </div>
            @if (model().integration?.landingPageType != 1) {
              <div class="ft-panel" ft-targets-modal="flipto.prestay.landing.switch-to-integrated"
                   [class.read-only]="!allowToggleLandingPageType(1)"
                   (click)="allowToggleLandingPageType(1) && showModal('flipto.prestay.landing.switch-to-integrated')">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.Status' | translate }}:</div></div>
                  <div class="ft-col-66"><div [innerHTML]="(model().integration?.landingPageType == 1 | onOff)"></div></div>
                </div>
              </div>
            }
          </div>
        </ft-screen>

        <ft-screen name="landing-custom">
          <div [hidden]="screenName() !== 'landing-custom'">
            <p class="ft-summary" [innerHTML]="'flipto.account.LandingPageCustomDescription' | translate"></p>
            @if (model().languages?.length == 1) {
              @for (language of model().languages; track language) {
                <div class="ft-panel static"
                     [class.disabled]="!(langData(language.code)['landingPageHtml'] || '').length">
                  @if ((langData(language.code)['landingPageHtml'] || '').length) {
                    <div>
                      <div class="ft-label">{{ 'flipto.account.LandingPage' | translate }}:</div>
                      <div class="panel-actions">
                        <a class="ft-btn ft-btn-text" target="_blank"
                           [href]="(model().integration?.subdomains | cnameUrl:2:model().property?.Slug:langData(language.code).livePreviewQueryParams)">
                          {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                        </a>
                        <a class="ft-btn ft-btn-outline-dark" (click)="editLandingPageHtml(language.code)">{{ 'flipto.account.Edit' | translate }}</a>
                      </div>
                    </div>
                  }
                  @if (!(langData(language.code)['landingPageHtml'] || '').length) {
                    <div>
                      <div class="ft-label">{{ 'flipto.account.LandingPage' | translate }}:</div>
                      <div class="panel-actions">
                        <a class="ft-btn ft-btn-outline-dark" (click)="editLandingPageHtml(language.code)">{{ 'flipto.account.Create' | translate }}</a>
                      </div>
                    </div>
                  }
                </div>
              }
            }
            <div class="ft-multi-panel">
              @for (language of (model().languages?.length > 1 ? model().languages : []); track language) {
                <div class="ft-panel static"
                     [class.disabled]="!(langData(language.code)['landingPageHtml'] || '').length">
                  @if ((langData(language.code)['landingPageHtml'] || '').length) {
                    <div>
                      <div class="ft-label">{{ 'flipto.account.LandingPageFor' | translate:{ name: language.name } }}</div>
                      <div class="panel-actions">
                        <a class="ft-btn ft-btn-text" target="_blank"
                           [href]="(model().integration?.subdomains | cnameUrl:2:model().property?.Slug:langData(language.code).livePreviewQueryParams)">
                          {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                        </a>
                        <a class="ft-btn ft-btn-outline-dark" (click)="editLandingPageHtml(language.code)">{{ 'flipto.account.Edit' | translate }}</a>
                      </div>
                    </div>
                  }
                  @if (!(langData(language.code)['landingPageHtml'] || '').length) {
                    <div>
                      <div class="ft-label">{{ 'flipto.account.LandingPageFor' | translate:{ name: language.name } }}</div>
                      <div class="panel-actions">
                        <a class="ft-btn ft-btn-outline-dark" (click)="editLandingPageHtml(language.code)">{{ 'flipto.account.Create' | translate }}</a>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="ft-panel" ft-modal-fields-editor (click)="editLandingJsonCustomSettings()">
              <div class="ft-row">
                <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.JsonSettings' | translate }}:</div></div>
                <div class="ft-col-66"><div [innerHTML]="placeholderHtml(model().integration?.jsonCustomSettings)"></div></div>
              </div>
            </div>
            @if (model().integration?.landingPageType != 2) {
              <div class="ft-panel" ft-targets-modal="flipto.prestay.landing.switch-to-custom"
                   [class.read-only]="!allowToggleLandingPageType(2)"
                   (click)="allowToggleLandingPageType(2) && showModal('flipto.prestay.landing.switch-to-custom')">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.Status' | translate }}:</div></div>
                  <div class="ft-col-66"><div [innerHTML]="(model().integration?.landingPageType == 2 | onOff)"></div></div>
                </div>
              </div>
            }
          </div>
        </ft-screen>

        <ft-screen name="landing-hosted">
          <div [hidden]="screenName() !== 'landing-hosted'">
            <p class="ft-summary" [innerHTML]="'flipto.account.LandingPageHostedDescription' | translate"></p>
            @if (model().integration?.landingPageType != 3) {
              <div class="ft-panel" ft-targets-modal="flipto.prestay.landing.switch-to-hosted"
                   [class.read-only]="!allowToggleLandingPageType(3)"
                   (click)="allowToggleLandingPageType(3) && showModal('flipto.prestay.landing.switch-to-hosted')">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.Status' | translate }}:</div></div>
                  <div class="ft-col-66"><div [innerHTML]="(model().integration?.landingPageType == 3 | onOff)"></div></div>
                </div>
              </div>
            }
            @if (model().integration?.landingPageType != 3 && model().languageItems && model().languageItems[0]?.data?.promoterCode) {
              <div class="ft-panel static">
                <a class="ft-btn ft-btn-text" target="_blank" [href]="getLandingPagePreviewUrl('hosted')">
                  {{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i>
                </a>
              </div>
            }
          </div>
        </ft-screen>
      </div>
    </div>

    <div class="ft-row" [hidden]="model().integration?.landingPageType == 3">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'language.Advanced' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel last" ft-modal-fields-editor (click)="editLandingRedirectUrl()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.signupRedirectUrl' | translate }}:</div>
              <div class="ft-summary">{{ 'flipto.account.platform.preStay.touchpoints.signupRedirectUrlSummary' | translate }}</div>
            </div>
            <div class="ft-col-66"><div class="url-text" [innerHTML]="placeholderHtml(langData('en')['postSignupRedirectUrl'])"></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}

@case ('confirmation') {
<section class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'language.Configuration' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        @for (engine of model().bookingEngines; track engine) {
        <div>
          <div class="ft-panel" ft-targets-modal="confirmation.editEngineCodesModal"
               (click)="selectBookingEngine(engine); showModal('confirmation.editEngineCodesModal')">
            <div class="ft-row">
              <div class="ft-col-33">
                <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.BookingEngine' | translate }}:</div>
              </div>
              <div class="ft-col-66">{{ model().engineNames[engine.type] }}</div>
            </div>
            <div class="ft-row">
              <div class="ft-col-33">
                <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.PropertyCode' | translate }}:</div>
              </div>
              <div class="ft-col-66">
                @for (code of engine.codes.item; track code; let last = $last) {<span>{{ code.code }}{{ !last ? ', ' : '' }}</span>}
                @if (engine.codes.item.length === 0) {<span class="placeholder">{{ 'flipto.account.NoCodesSet' | translate }}</span>}
              </div>
            </div>
          </div>
          <div class="ft-panel last" ft-targets-modal="confirmation.appmodes"
               (click)="selectBookingEngine(engine); showModal('confirmation.appmodes')">
            <div class="ft-row">
              <div class="ft-col-33">
                <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ConfirmationDisplayType' | translate }}:</div>
              </div>
              <div class="ft-col-66">{{ engine.confirmationDisplayType | confirmationDisplayType }}</div>
            </div>
            @if (engine.confirmationDisplayType != 3) {
              <div class="ft-row">
                <div class="ft-col-33">
                  <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.Selector' | translate }}:</div>
                </div>
                <div class="ft-col-66">{{ engine.selector }}</div>
              </div>
            }
            <div class="panel-status" [hidden]="engine.isActive != '0'">{{ 'flipto.account.platform.preStay.touchpoints.Off' | translate }}</div>
          </div>
        </div>
        }
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'language.Advanced' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel read-only">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.FliptoAccountCode' | translate }}:</div>
            </div>
            <div class="ft-col-66">
              <div>{{ model().integration.companyCode }}</div>
            </div>
          </div>
        </div>
        <div class="ft-panel last" ft-targets-modal="integration.rateCodes" (click)="showModal('integration.rateCodes')">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ExcludedReservationTypes' | translate }}:</div>
            </div>
            <div class="ft-col-66">
              @for (rateCode of model().rateCodes; track rateCode; let last = $last) {<span>{{ rateCode }}{{ !last ? ', ' : '' }}</span>}
              @if (model().rateCodes.length === 0) {<span class="placeholder">{{ 'flipto.account.platform.preStay.touchpoints.NoRateCodes' | translate }}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}

<!-- WS4 inc 6 grind: PHOTO-RIVER "Story River" integration (edit-photo-river-integration.html).
     Configuration: PageLocation (selector) / InsertionType (| insertionType) / ExternalLinks
     (isDesktopOpenNewWindow) panels — each opens a bridged ft-modal via ft-targets-modal click.
     Advanced: Flip.to account code (read-only). All 3 modals on-done=commit. -->
@case ('photo-river') {
<section class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.Configuration' | translate }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-targets-modal="photo.river.editPageLocationModal" (click)="showModal('photo.river.editPageLocationModal')">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'language.PageLocation' | translate }}:</div></div>
            <div class="ft-col-66"><span>{{ model().integration?.selector }}@if (!model().integration?.selector) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</span></div>
          </div>
        </div>
        <div class="ft-panel" ft-targets-modal="photo.river.editInsertionTypeModal" (click)="showModal('photo.river.editInsertionTypeModal')">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.InsertionType' | translate }}:</div></div>
            <div class="ft-col-66">{{ insertionTypeLabel() }}@if (!insertionTypeLabel()) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div>
          </div>
        </div>
        <div class="ft-panel" ft-targets-modal="photo.river.editExternalLinksModal" (click)="showModal('photo.river.editExternalLinksModal')">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.ExternalLinks' | translate }}:</div>
              <div class="ft-summary">{{ 'flipto.account.sections.platform.photoAdvocacy.ExternalLinksPanelSummary' | translate }}</div>
            </div>
            <div class="ft-col-66">{{ model().integration?.isDesktopOpenNewWindow ? 'Opens in new window' : 'Opens in same window' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.Advanced' | translate }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel last read-only">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.FliptoAccountCode' | translate }}:</div></div>
            <div class="ft-col-66"><div>{{ model().integration?.companyCode }}</div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}

<!-- WS4 inc 6 grind: QUOTE-LIST "Quotes List" integration (edit-list-integration.html).
     Configuration: ProfileImage (UseGuestPhoto/ReplaceGuestPhoto select) / NumberOfQuotesToFeature
     (pageSize) / QuoteCharacterLimit (maxQuoteTextLength) number editors. AdvancedSettings:
     TouchpointCode (codes, sets tempTransformType=8) / Json (jsonSettings) / Flip.to code. -->
@case ('list') {
<section class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.Configuration' | translate | uppercase }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-targets-modal="profileImageTypeModal" (click)="showModal('profileImageTypeModal')">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.ProfileImage' | translate }}:</div></div>
            <div class="ft-col-66"><div>{{ profileImageTypeName() }}</div></div>
          </div>
        </div>
        <div class="ft-panel" ft-modal-fields-editor (click)="editListPageSize()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.quoteList.touchpoints.NumberOfQuotesToFeature' | translate }}:</div></div>
            <div class="ft-col-66"><span>{{ model().integration?.pageSize }}@if (!model().integration?.pageSize) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</span></div>
          </div>
        </div>
        <div class="ft-panel last" ft-modal-fields-editor (click)="editListMaxQuoteLength()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.quoteList.touchpoints.QuoteCharacterLimit' | translate }}:</div></div>
            <div class="ft-col-66"><span>{{ model().integration?.maxQuoteTextLength }}@if (!model().integration?.maxQuoteTextLength) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.AdvancedSettings' | translate | uppercase }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-targets-modal="editCodesModal" (click)="onEditListCodes()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.quoteList.touchpoints.TouchpointCode' | translate }}:</div></div>
            <div class="ft-col-66">
              @for (code of (model().integration?.codes?.item || []); track code; let last = $last) {<span>{{ code.code }}{{ !last ? ', ' : '' }}</span>}
              @if (!(model().integration?.codes?.item?.length)) {<span class="placeholder">{{ 'flipto.account.NoCodesSet' | translate }}</span>}
            </div>
          </div>
        </div>
        <div class="ft-panel" ft-modal-fields-editor (click)="editListJsonSettings()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.quoteList.touchpoints.Json' | translate }}:</div></div>
            <div class="ft-col-66"><div [innerHTML]="placeholderHtml(model().integration?.jsonSettings)"></div></div>
          </div>
        </div>
        <div class="ft-panel last read-only">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.FliptoAccountCode' | translate }}:</div></div>
            <div class="ft-col-66"><div>{{ model().integration?.companyCode }}</div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}

<!-- WS4 inc 6 grind: HOMEPAGE "Homepage Component" integration (edit-homepage-integration.html).
     Configuration: ProfileImage select + HomepageComponentCode (codes, tempTransformType=8).
     Advanced: Json (editHomepageIntegrationModal, tempTransformType=1) + Flip.to code. Reuses the
     homepage/list model branch (profileImageTypes) + the 3 bridged modals. -->
@case ('homepage') {
<section class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.Configuration' | translate }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-targets-modal="profileImageTypeModal" (click)="showModal('profileImageTypeModal')">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.ProfileImage' | translate }}:</div></div>
            <div class="ft-col-66"><div>{{ profileImageTypeName() }}</div></div>
          </div>
        </div>
        <div class="ft-panel last" ft-targets-modal="editCodesModal" (click)="onEditHomepageCodes()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.HomepageComponentCode' | translate }}:</div></div>
            <div class="ft-col-66">
              @for (code of (model().integration?.codes?.item || []); track code; let last = $last) {<span>{{ code.code }}{{ !last ? ', ' : '' }}</span>}
              @if ((model().integration?.codes?.item?.length || 0) < 1) {<div class="placeholder">{{ 'flipto.account.NoCodesSet' | translate }}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.Advanced' | translate }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-targets-modal="editHomepageIntegrationModal" (click)="onEditHomepageJson()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.Json' | translate }}:</div></div>
            <div class="ft-col-66"><div [innerHTML]="placeholderHtml(model().integration?.jsonSettings)"></div></div>
          </div>
        </div>
        <div class="ft-panel last read-only">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.FliptoAccountCode' | translate }}:</div></div>
            <div class="ft-col-66"><div>{{ model().integration?.companyCode }}</div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}

<!-- WS4 inc 6 grind (LAST touchpoint editor): quote "Post-stay Process" integration
     (edit-quote-integration.html). NON-versioned (resolveTempalteUrl returns the plain edit-*.html
     for dataType=integration → NO version chrome; baseline-probed: no version-alert/sheet-tabs/sheet-body).
     Configuration panels open the bridged ftModalFieldsEditor (commit / commitLanguages); the
     place-info panels + allowed-places ft-select-editor are Flip.to-staff only. -->
@case ('quote') {
<section class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header"><div class="ft-label">{{ 'language.Configuration' | translate }}</div></div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-modal-fields-editor [class.read-only]="isEnablePhotosDisabled()" (click)="editQuoteIsEnablePhotos()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">Invite guests to storyteller campaign</div></div>
            <div class="ft-col-66">{{ model().integration?.isEnablePhotos | onOff }}</div>
          </div>
        </div>

        @if (model().integration?.mode === '4' || model().integration?.mode === '0') {
          <div class="ft-panel" ft-modal-fields-editor
               [class.read-only]="version.currentIsNewVersion && version.currentIsNewVersion()" (click)="editQuoteSelector()">
            <div class="ft-row">
              <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.postStay.touchpoints.Integration.Selector' | translate }}</div></div>
              <div class="ft-col-66"><div [innerHTML]="placeholderHtml(model().integration?.selector)"></div></div>
            </div>
          </div>
        }

        <div class="ft-panel" ft-modal-fields-editor [class.read-only]="version.currentIsNewVersion && version.currentIsNewVersion()" (click)="editQuoteExternalReviewUrl()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.postStay.touchpoints.ExternalReviewUrl' | translate }}</div></div>
            <div class="ft-col-66"><div class="url-text" [innerHTML]="placeholderHtml(langData('en')['finalExternalReviewUrl'])"></div></div>
          </div>
        </div>

        <div class="ft-panel" ft-modal-fields-editor [class.read-only]="version.currentIsNewVersion && version.currentIsNewVersion()" (click)="editQuoteIsLowRatingExternalReview()">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.postStay.touchpoints.Integration.IsLowRatingExternalReview' | translate }}</div></div>
            <div class="ft-col-66">{{ model().integration?.isLowRatingExternalReview | onOff }}</div>
          </div>
        </div>

        @if (isFliptoStaff()) {
          <div class="ft-panel" ft-modal-fields-editor (click)="editQuotePlacePhoto()">
            <div class="ft-row">
              <div class="ft-col-33"><div class="ft-label">Request place info for photo</div></div>
              <div class="ft-col-66">{{ model().integration?.isRequestPlaceForPhotoEnabled | onOff }}@if (model().integration?.isRequestPlaceForPhotoEnabled) {<span>, {{ model().integration?.isRequestPlaceForPhotoRequired ? 'required' : 'optional' }}</span>}</div>
            </div>
          </div>
        }

        @if (isFliptoStaff()) {
          <div class="ft-panel" ft-modal-fields-editor (click)="editQuotePlaceQuote()">
            <div class="ft-row">
              <div class="ft-col-33"><div class="ft-label">Request place info for quote</div></div>
              <div class="ft-col-66">{{ model().integration?.isRequestPlaceForQuoteEnabled | onOff }}@if (model().integration?.isRequestPlaceForQuoteEnabled) {<span>, {{ model().integration?.isRequestPlaceForQuoteRequired ? 'required' : 'optional' }}</span>}</div>
            </div>
          </div>
        }

        @if (isFliptoStaff()) {
          <ft-select-editor title="Allowed places"
                            summary="Set which places should be available for your audience to select from. You can choose the 'Your places' option if you configure it in Mission Control."
                            [value]="model().integration?.allowedPlacesType"
                            (save)="onAllowedPlacesSave($event)"
                            [options]="model().allowedPlacesTypes"
                            [bindValue]="'value'"
                            [bindLabel]="'label'">
            <ft-edit-panel label="Allowed places">
              @for (option of model().allowedPlacesTypes; track option) {
                @if (option.value == model().integration?.allowedPlacesType) {
                  <div class="ml-2">{{ option.label }}</div>
                }
              }
            </ft-edit-panel>
          </ft-select-editor>
        }
      </div>
    </div>
  </div>
</section>
}

<!-- WS5 Phase 3 #6: photo-advocacy contestPage "Story Explorer" INTEGRATION
     (edit-contestPage-integration.html). Read-view ported VERBATIM (5 panels:
     Property code / Story Explorer URL + Old URL / Book Now / Show footer /
     Flip.to account code). This replaces the touchpoint container's v1
     mountV1Tab $compile fallback (the LAST reachable non-native integration
     tab; contestPage added to NATIVE_INTEGRATION_TOUCHPOINTS, mountV1Tab deleted).
     The 2 edit ft-modals (editPhotoIntegrationModal codes + footerEditor) are
     native ft-modal-overlay blocks (#7/#7h) and Book Now is the native
     FtFieldEditorModalComponent — buildModals is DELETED (inc 2x). WS5 #10 Stage B B1:
     all URL/text field editors are now native FtFieldEditorModalComponent too (the
     fieldsEditor.open bridge is fully drained from this file).
     permanentTransformType=8 (the v1 ng-init) is set for contestPage in initModel.
     WS5 #10 Stage B B0 (#7h): the contestPage-only langChanges branch + the
     isBookNowActive/isFooterActive parse.bool are now PORTED (commit() + initModel) —
     a footer-content edit serializes model.languageItems diffs as changes.languages
     (transform 8 doesn't serialize footerContent), byte-identical to v1
     integration.controller.js:201-215; adjudicated + diag-proven by
     account-parity/_diag-footer-langchanges-7h.mjs. -->
@case ('contestPage') {
<section class="ft-section ft-config-section">
  <div class="ft-container">
    <div class="ft-row">
      <div class="ft-col-33">
        <div class="ft-section-header">
          <div class="ft-label">{{ 'language.Configuration' | translate }}</div>
        </div>
      </div>
      <div class="ft-col-66">
        <div class="ft-panel" ft-targets-modal="editPhotoIntegrationModal" (click)="showModal('editPhotoIntegrationModal')">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.PropertyCode' | translate }}:</div></div>
            <div class="ft-col-66">
              @if ((model().integration?.codes?.item?.length || 0) === 0) {<div class="placeholder">{{ 'flipto.account.NoCodesSet' | translate }}</div>}
              @for (code of (model().integration?.codes?.item || []); track code; let last = $last) {<span>{{ code.code }}{{ !last ? ', ' : '' }}</span>}
            </div>
          </div>
        </div>
        <div class="ft-panel static">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.PhotoExplorerUrl' | translate }}:</div></div>
            <div class="ft-col-66">
              <a class="url-text" target="_blank" [href]="(model().integration?.subdomains | cnameUrl:1:model().property?.Slug)">
                <span>{{ (model().integration?.subdomains | cnameUrl:1:model().property?.Slug) }}</span>
              </a>
            </div>
          </div>
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.OldUrl' | translate }}:</div></div>
            <div class="ft-col-66">
              <a class="url-text" target="_blank" [href]="langData('en')['landingPageUrl']">
                <span>{{ langData('en')['landingPageUrl'] }}</span>
              </a>
            </div>
          </div>
        </div>
        <div class="ft-panel" [class.read-only]="!isFliptoStaff()">
          <div class="ft-row" ft-modal-fields-editor (click)="editBookNow()">
            <!-- [innerHTML] like v1's ng-bind-html — the value carries &ldquo;/&rdquo; entities
                 that must render as curly quotes, not literal text. -->
            <div class="ft-col-33"><div class="ft-label" [innerHTML]="('flipto.account.ShowBookNowButtonInNav' | translate) + ':'"></div></div>
            <div class="ft-col-66">{{ model().integration?.isBookNowActive | onOff }}</div>
          </div>
        </div>
        <div class="ft-panel" ft-targets-modal="flipto.photo-explorer.integration.footerEditor" [class.read-only]="!isFliptoStaff()"
             (click)="showModal('flipto.photo-explorer.integration.footerEditor')">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.ShowFooter' | translate }}:</div></div>
            <div class="ft-col-66">{{ model().integration?.isFooterActive | onOff }}</div>
          </div>
          @if (model().integration?.isFooterActive && footerContentEn()) {
            <div class="ft-row">
              <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.FooterContent' | translate }}:</div></div>
              <div class="ft-col-66"><div class="html-text">{{ footerContentEn() }}</div></div>
            </div>
          }
        </div>
        <div class="ft-panel last read-only">
          <div class="ft-row">
            <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.FliptoAccountCode' | translate }}:</div></div>
            <div class="ft-col-66"><div>{{ model().integration?.companyCode }}</div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
}

}

<ft-field-editor-modal [config]="fieldEditorConfig()" (closed)="fieldEditorConfig.set(null)" />

<!-- WS5 #10 inc 2x: the friend-landing switch-to-X confirmation trio, native (the LAST bridged
     ftModals in this file — replaces the buildModals fieldsEditor.compile of the 3 bare
     <ft-modal header-text/header-description/done-text="MakeSwitch" on-done="set<X>LandingPageType">).
     Chrome-only (no body content), v1 defaults: Done(MakeSwitch) + X, size sm; done runs the
     setter then hides; X just hides. -->
<ft-modal-overlay [open]="switchLandingModal() === 1">
  @if (switchLandingModal() === 1) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.SwitchToIntegrated' | translate"
    [headerDescription]="'flipto.account.SwitchToIntegratedDescription' | translate"
    [doneText]="'flipto.account.MakeSwitch' | translate"
    size="sm"
    (done)="onSwitchLandingDone()"
    (cancel)="switchLandingModal.set(null)"
   />
  }
</ft-modal-overlay>
<ft-modal-overlay [open]="switchLandingModal() === 2">
  @if (switchLandingModal() === 2) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.SwitchToCustom' | translate"
    [headerDescription]="'flipto.account.SwitchToCustomDescription' | translate"
    [doneText]="'flipto.account.MakeSwitch' | translate"
    size="sm"
    (done)="onSwitchLandingDone()"
    (cancel)="switchLandingModal.set(null)"
   />
  }
</ft-modal-overlay>
<ft-modal-overlay [open]="switchLandingModal() === 3">
  @if (switchLandingModal() === 3) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.SwitchToHosted' | translate"
    [headerDescription]="'flipto.account.SwitchToHostedDescription' | translate"
    [doneText]="'flipto.account.MakeSwitch' | translate"
    size="sm"
    (done)="onSwitchLandingDone()"
    (cancel)="switchLandingModal.set(null)"
   />
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the confirmation Integration "Excluded Reservation Types" (RateCodes)
     modal, native. Replaces the bridged RATE_CODES <ft-modal on-done="saveRateCodes"
     ft-snapshot="model.rateCodes"> compile. The v1 ft-list-editor renders as a plain transclude
     <div> (input + add-item button); ft-list renders removable .list-item rows (btn-delete-item).
     Add: Enter uses the raw value, the + button uses .toUpperCase() (v1 ft-add-to-list parity);
     unique dedup. DIRECT-save: Done → saveRateCodes() (RateCodes.updateRateCodes API); X/Cancel
     reverts the model.rateCodes snapshot in place. -->
<ft-modal-overlay [open]="rateCodesModalOpen()">
  @if (rateCodesModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.platform.preStay.touchpoints.ExcludedReservationTypes' | translate"
    [headerDescription]="'flipto.account.platform.preStay.touchpoints.RateCodesSummary' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onRateCodesDone()"
    (cancel)="onRateCodesCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div>
        <input
          placeholder="{{ 'flipto.account.platform.preStay.touchpoints.RateCodeAdd' | translate }}"
          name="rateCodes"
          [(ngModel)]="model().newRateCode"
          [ngModelOptions]="{ standalone: true }"
          (keydown.enter)="addRateCodeFromEnter($event)"
        />
        <button type="button" class="ft-btn ft-btn-default add-item" (click)="addRateCodeFromButton()">
          <i class="ft-icn-plus"></i>
        </button>
      </div>
    </div>
    <div class="modal-panel">
      @for (rateCode of model().rateCodes; track rateCode; let i = $index) {
      <div class="list-item">
        <span>{{ rateCode }}</span>
        <span>&nbsp;</span>
        <button type="button" class="btn-delete-item" (click)="removeRateCode(i)"></button>
      </div>
      }
      @if (model().rateCodes.length === 0) {<div class="placeholder">
        {{ 'flipto.account.platform.preStay.touchpoints.NoRateCodes' | translate }}
      </div>}
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the confirmation Integration per-engine "Booking Engine" (editEngineCodes)
     modal, native. Replaces the bridged ENGINE_CODES <ft-modal on-done="commit"
     ft-snapshot="model.bookingEngines"> compile. Composite: native ft-select-ng (engine type;
     [(selectedKey)]="model.selectedEngine.type" = v1 selected-item/selected-item-key) + inline
     .ft-switch (isActive, on-change → updateBookingEngineState immediate activate API) + the inline
     list-editor (codes, map=code → {code}) + removable .list-item list. DIFF-save: Done →
     commit(computeDiffs(snapshot, model.bookingEngines)) (BookingEngineIntegrationData, multiEngine);
     X/Cancel → revertDiffs. -->
<ft-modal-overlay [open]="engineCodesModalOpen()">
  @if (engineCodesModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.platform.preStay.touchpoints.BookingEngine' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onEngineCodesDone()"
    (cancel)="onEngineCodesCancel()"
  >
    <div class="modal-panel">
      <ft-select-ng [items]="model().engines" key="id" value="name" [(selectedKey)]="model().selectedEngine.type" />
      <div class="ft-switch">
        <input
          class="ft-switch-toggle"
          type="checkbox"
          [id]="engineActiveUid"
          [checked]="model().selectedEngine.isActive"
          (change)="onEngineActiveToggle($event)"
        />
        <label [attr.for]="engineActiveUid"></label>
      </div>
    </div>
    <div>&nbsp;</div>
    <div class="modal-panel modal-panel-input">
      <div>
        <input
          placeholder="{{ 'flipto.account.platform.preStay.touchpoints.AddCode' | translate }}"
          name="codes"
          [(ngModel)]="model().codeInModal"
          [ngModelOptions]="{ standalone: true }"
          (keydown.enter)="addEngineCodeFromEnter($event)"
        />
        <button type="button" class="ft-btn ft-btn-default add-item" (click)="addEngineCodeFromButton()">
          <i class="ft-icn-plus"></i>
        </button>
      </div>
    </div>
    <div class="modal-panel">
      @for (code of model().selectedEngine.codes.item; track code; let i = $index) {
      <div class="list-item">
        <span>{{ code.code }}</span>
        <span>&nbsp;</span>
        <button type="button" class="btn-delete-item" (click)="removeEngineCode(i)"></button>
      </div>
      }
      @if (!model().selectedEngine.codes?.item?.length) {<div class="placeholder">
        {{ 'flipto.account.NoCodesSet' | translate }}
      </div>}
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the confirmation Integration per-engine "Confirmation Display Type"
     (appmodes) modal, native. Replaces the bridged APPMODES <ft-modal on-done="commit"> compile.
     A native ft-select-ng (displayType) drives two *ngIf branches (v1 loose != 3 / == 3): the !=3
     branch = selector text input + insertionType select + Desktop/Mobile reopener switches; the
     ==3 branch = timer switch + conditional timerActionType select + incentive switch. The
     non-side-effect switches use the generic onSwitchToggle helper. DIFF-save: Done →
     commit(computeDiffs(snapshot, model.bookingEngines)); X/Cancel → revertDiffs. -->
<ft-modal-overlay [open]="appmodesModalOpen()">
  @if (appmodesModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.platform.preStay.touchpoints.ConfirmationDisplayType' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onAppmodesDone()"
    (cancel)="onAppmodesCancel()"
  >
    <div class="modal-panel">
      <ft-select-ng [items]="model().enums.confirmationDisplayTypes" key="id" value="name" [(selectedKey)]="model().selectedEngine.confirmationDisplayType" />
    </div>
    @if (model().selectedEngine.confirmationDisplayType != 3) {
    <div>
      <div class="modal-section-heading">{{ 'flipto.account.platform.preStay.touchpoints.ParentElementSelector' | translate }}</div>
      <div class="modal-panel modal-panel-input">
        <input
          type="text"
          [(ngModel)]="model().selectedEngine.selector"
          [ngModelOptions]="{ standalone: true }"
          placeholder="{{ 'flipto.account.platform.preStay.touchpoints.AddDomSelector' | translate }}"
        />
      </div>
      <div class="modal-section-heading">{{ 'flipto.account.sections.platform.photoAdvocacy.InsertionType' | translate }}</div>
      <div class="modal-panel">
        <ft-select-ng [items]="model().enums.insertionTypes" key="id" value="description" [(selectedKey)]="model().selectedEngine.insertionType" />
      </div>
      <div class="modal-section-heading">{{ 'flipto.account.platform.preStay.touchpoints.ReopenerHeader' | translate }}</div>
      <div class="modal-panel">
        <div class="ft-label">{{ 'flipto.account.Desktop' | translate }}</div>
        <div class="ft-switch">
          <input class="ft-switch-toggle" type="checkbox" [id]="reopenerDesktopUid" [checked]="model().selectedEngine.isDesktopReopenerActive" (change)="onSwitchToggle(model().selectedEngine, 'isDesktopReopenerActive', $event)" />
          <label [attr.for]="reopenerDesktopUid"></label>
        </div>
      </div>
      <div class="modal-panel last">
        <div class="ft-label">{{ 'flipto.account.Mobile' | translate }}</div>
        <div class="ft-switch">
          <input class="ft-switch-toggle" type="checkbox" [id]="reopenerMobileUid" [checked]="model().selectedEngine.isMobileReopenerActive" (change)="onSwitchToggle(model().selectedEngine, 'isMobileReopenerActive', $event)" />
          <label [attr.for]="reopenerMobileUid"></label>
        </div>
      </div>
    </div>
    }
    @if (model().selectedEngine.confirmationDisplayType == 3) {
    <div>
      <div class="modal-section-heading">{{ 'flipto.account.platform.preStay.touchpoints.TimerHeader' | translate }}</div>
      <div class="modal-panel">
        <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.TimerEnabled' | translate }}</div>
        <div class="ft-switch">
          <input class="ft-switch-toggle" type="checkbox" [id]="timerEnabledUid" [checked]="model().selectedEngine.isTimerEnabled" (change)="onSwitchToggle(model().selectedEngine, 'isTimerEnabled', $event)" />
          <label [attr.for]="timerEnabledUid"></label>
        </div>
      </div>
      @if (model().selectedEngine.isTimerEnabled) {
        <div>
          <div class="modal-panel">
            <ft-select-ng [items]="model().enums.confirmationTimerActionTypes" key="id" value="name" [(selectedKey)]="model().selectedEngine.timerActionType" />
          </div>
        </div>
      }
      <div class="modal-section-heading">{{ 'flipto.account.platform.preStay.touchpoints.IncentiveHeader' | translate }}</div>
      <div class="modal-panel">
        <div class="ft-label">{{ 'flipto.account.platform.preStay.touchpoints.ShowIncentiveOnIntro' | translate }}</div>
        <div class="ft-switch">
          <input class="ft-switch-toggle" type="checkbox" [id]="incentiveUid" [checked]="model().selectedEngine.isShowIncentiveOnIntro" (change)="onSwitchToggle(model().selectedEngine, 'isShowIncentiveOnIntro', $event)" />
          <label [attr.for]="incentiveUid"></label>
        </div>
      </div>
    </div>
    }
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7: the contestPage "Property code" (editPhotoIntegrationModal) codes editor,
     native. Replaces the bridged EDIT_PHOTO_CODES <ft-modal on-done="commit"
     ft-snapshot="model.integration.codes"> compile — its own CDK overlay stacks above the CDK
     touchpoint sheet (the bridged v1 ftModal at z3000 was occluded behind it). Native list-editor
     (input + add-item + removable .list-item list) on model.integration.codes.item (map=code), same
     markup as the rateCodes/engineCodes overlays. Done → commit(diffs) (permanentTransformType=8 →
     TouchpointCode); X/Cancel → revertDiffs(model.integration). -->
<ft-modal-overlay [open]="editPhotoCodesModalOpen()">
  @if (editPhotoCodesModalOpen()) {
  <ft-modal-chrome-ng
    headerText="Property code"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onEditPhotoCodesDone()"
    (cancel)="onEditPhotoCodesCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div>
        <input
          placeholder="{{ 'flipto.account.platform.preStay.touchpoints.AddCode' | translate }}"
          name="code"
          [(ngModel)]="model().codesInModal"
          [ngModelOptions]="{ standalone: true }"
          (keydown.enter)="addPhotoCodeFromEnter($event)"
        />
        <button type="button" class="ft-btn ft-btn-default add-item" (click)="addPhotoCodeFromButton()">
          <i class="ft-icn-plus"></i>
        </button>
      </div>
    </div>
    <div class="modal-panel">
      @for (code of model().integration.codes.item; track code; let i = $index) {
      <div class="list-item">
        <span>{{ code.code }}</span>
        <span>&nbsp;</span>
        <button type="button" class="btn-delete-item" (click)="removePhotoCode(i)"></button>
      </div>
      }
      @if (!model().integration.codes?.item?.length) {<div class="placeholder">
        {{ 'flipto.account.NoCodesSet' | translate }}
      </div>}
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7e: photo-river "Page location" (editPageLocationModal), native. Replaces the
     bridged PAGE_LOCATION <ft-modal on-done="commit" ft-snapshot="model.integration"> compile.
     Body = the v1 summary + a CSS-selector text input bound to model.integration.selector. -->
<ft-modal-overlay [open]="pageLocationModalOpen()">
  @if (pageLocationModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'language.PageLocation' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onPhotoRiverDone()"
    (cancel)="onPhotoRiverCancel()"
  >
    <div class="modal-summary">{{ 'flipto.account.sections.platform.photoAdvocacy.PageLocationModalSummary' | translate }}</div>
    <div class="modal-panel modal-panel-input">
      <input
        type="text"
        [(ngModel)]="model().integration.selector"
        [ngModelOptions]="{ standalone: true }"
        placeholder="{{ 'language.AddCssSelector' | translate }}"
      />
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7e: photo-river "Insertion type" (editInsertionTypeModal), native. Replaces the
     bridged INSERTION_TYPE compile. Body = native ft-select-ng (insertionTypes, value=description)
     bound to model.integration.insertionType. v1 disabled-field=!identity.isFliptoStaff() is
     omitted (ft-select-ng has no [disabled]; quebec QA login is staff → enabled on both hosts). -->
<ft-modal-overlay [open]="insertionTypeModalOpen()">
  @if (insertionTypeModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.sections.platform.photoAdvocacy.InsertionType' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onPhotoRiverDone()"
    (cancel)="onPhotoRiverCancel()"
  >
    <div class="modal-panel">
      <ft-select-ng [items]="model().enums.insertionTypes" key="id" value="description" [(selectedKey)]="model().integration.insertionType" />
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7e: photo-river "External links" (editExternalLinksModal), native. Replaces the
     bridged EXTERNAL_LINKS compile. Body = the v1 summary + an inline .ft-switch (NOT <ft-switch>,
     the E-selector collides with the AngularJS ftSwitch directive in a body-level CDK overlay)
     bound to model.integration.isDesktopOpenNewWindow. -->
<ft-modal-overlay [open]="externalLinksModalOpen()">
  @if (externalLinksModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.sections.platform.photoAdvocacy.ExternalLinks' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onPhotoRiverDone()"
    (cancel)="onPhotoRiverCancel()"
  >
    <div class="modal-summary">{{ 'flipto.account.sections.platform.photoAdvocacy.ExternalLinksModalSummary' | translate }}</div>
    <div class="modal-panel">
      <div class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.OpenLinksInNewWindow' | translate }}</div>
      <div class="ft-switch">
        <input
          class="ft-switch-toggle"
          type="checkbox"
          [id]="externalLinksSwitchUid"
          [checked]="model().integration.isDesktopOpenNewWindow"
          (change)="onSwitchToggle(model().integration, 'isDesktopOpenNewWindow', $event)"
        />
        <label [attr.for]="externalLinksSwitchUid"></label>
      </div>
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7f: the list + homepage "Profile image" (profileImageTypeModal) select editor,
     native. Replaces the bridged PROFILE_IMAGE <ft-modal ft-snapshot="model.integration"
     on-done="commit"> compile (its own CDK overlay stacks above the CDK touchpoint sheet — the
     bridged v1 ftModal at z3000 was occluded behind it). Body = native ft-select-ng
     (UseGuestPhoto / ReplaceGuestPhoto, value=name); (change) fires syncProfileImageType() — the
     v1 $watch side-effect that keeps model.integration.isReplacePictures in sync with the picked
     id (the [(selectedKey)] two-way writes selectedImageProfileType.id first). Snapshot
     model.integration -> Done commit(diffs) FlatData; X/Cancel -> revertDiffs. The homepage panel
     is .last (v1 modal-panel last); the list panel is plain modal-panel. -->
<ft-modal-overlay [open]="profileImageModalOpen()">
  @if (profileImageModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.platform.homepage.touchpoints.ProfileImage' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onProfileImageDone()"
    (cancel)="onProfileImageCancel()"
  >
    <div class="modal-panel" [class.last]="touchpointType() === 'homepage'">
      <ft-select-ng [items]="model().profileImageTypes"
        key="id"
        value="name"
        [(selectedKey)]="model().selectedImageProfileType.id"
        (change)="syncProfileImageType()"
       />
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7f: the list + homepage codes (editCodesModal) list-editor, native. Replaces
     the bridged EDIT_CODES <ft-modal on-done="commit" ft-snapshot="model.integration"> compile
     (shared id between list/homepage → ONE native overlay; the header is dynamic by
     touchpointType). Native list-editor (input + add-item + removable .list-item list) on
     model.integration.codes.item (map=code), same markup as the contestPage editPhotoCodes
     overlay (#7, reuses addPhotoCode*/removePhotoCode). onEditList/HomepageCodes set
     tempTransformType=8 BEFORE opening -> Done commit(diffs) serializes TouchpointCode; X/Cancel ->
     revertDiffs. The homepage list panel matches the v1 modal-panel-checklist > .ft-list
     nesting + list-item placeholder; the list panel matches the v1 flat modal-panel. -->
<ft-modal-overlay [open]="editCodesModalOpen()">
  @if (editCodesModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="codesModalHeader()"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onEditCodesDone()"
    (cancel)="onEditCodesCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div>
        <input
          placeholder="{{ 'flipto.account.platform.preStay.touchpoints.AddCode' | translate }}"
          name="codes"
          [(ngModel)]="model().codesInModal"
          [ngModelOptions]="{ standalone: true }"
          (keydown.enter)="addPhotoCodeFromEnter($event)"
        />
        <button type="button" class="ft-btn ft-btn-default add-item" (click)="addPhotoCodeFromButton()">
          <i class="ft-icn-plus"></i>
        </button>
      </div>
    </div>
    @if (touchpointType() !== 'homepage') {
    <div class="modal-panel">
      @for (code of model().integration.codes.item; track code; let i = $index) {
      <div class="list-item">
        <span>{{ code.code }}</span>
        <span>&nbsp;</span>
        <button type="button" class="btn-delete-item" (click)="removePhotoCode(i)"></button>
      </div>
      }
      @if (!model().integration.codes?.item?.length) {<div class="placeholder">
        {{ 'flipto.account.NoCodesSet' | translate }}
      </div>}
    </div>
    }
    @if (touchpointType() === 'homepage') {
    <div class="modal-panel modal-panel-checklist">
      <div class="ft-list">
        @for (code of model().integration.codes.item; track code; let i = $index) {
        <div class="list-item">
          <span>{{ code.code }}</span>
          <span>&nbsp;</span>
          <button type="button" class="btn-delete-item" (click)="removePhotoCode(i)"></button>
        </div>
        }
        @if (!model().integration.codes?.item?.length) {<div class="list-item placeholder">
          {{ 'flipto.account.NoCodesSet' | translate }}
        </div>}
      </div>
    </div>
    }
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- WS5 Phase 3 #7h: the contestPage "Footer" (footerEditor) editor, native. Replaces the bridged
     FOOTER_EDITOR <ft-modal on-done="commit" ft-snapshot="model.languageItems,
     model.integration.isFooterActive"> compile. ShowFooter inline .ft-switch (NOT ft-switch — the
     E-selector collides with the AngularJS ftSwitch directive in a body-level CDK overlay) +
     conditional FtHtmlField (footerContent, multi-language). Done -> commit(diffs)
     permanentTransformType=8 (transform 8 PhotoContestPageIntegration emits
     isBookNowActive/isFooterActive/codes; footerContent is NOT serialized by transform 8 — matches
     v1 byte-for-byte). X/Cancel -> revert BOTH the languageItems + integration snapshots (the v1
     dual ft-snapshot rollback). -->
<ft-modal-overlay [open]="footerModalOpen()">
  @if (footerModalOpen()) {
  <ft-modal-chrome-ng
    headerText="Footer"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onFooterDone()"
    (cancel)="onFooterCancel()"
  >
    <div class="modal-panel">
      <div class="ft-label">{{ 'flipto.account.ShowFooter' | translate }}</div>
      <div class="ft-switch">
        <input
          class="ft-switch-toggle"
          type="checkbox"
          [id]="footerSwitchUid"
          [checked]="model().integration.isFooterActive"
          (change)="onSwitchToggle(model().integration, 'isFooterActive', $event)"
        />
        <label [attr.for]="footerSwitchUid"></label>
      </div>
    </div>
    @if (model().integration.isFooterActive) {
      <div class="modal-section-heading">{{ 'flipto.account.FooterContent' | translate }}</div>
    }
    @if (model().integration.isFooterActive) {
      <ft-html-field-ng [datasource]="model().languageItems" [fields]="footerFields" />
    }
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>
